export default __webpack_public_path__ + "static/load-2b18fef1b756cca51a72575adfab1bfa.gif";